import React, {useState, useEffect} from "react";
import { Form, Input, Select, Tooltip, DatePicker } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import "./Filter.scss";

const Filter = ({values, placeholder, name, selected, reset, type, label, hint}) => {
  const { Option } = Select;
  const [state, setState] = useState(selected);

  useEffect(() => {
    if (reset) {
      setState([]);
    }
  }, [reset]);

  const handleChange = value => {
    setState(value);
  };

  const handleFilter = (inputValue, option) => {
    const str = `${option.key} - ${option.props.children}`;

    return str.match(new RegExp(inputValue, 'i'));
  }

  if (type === "date") {
    const RangePicker = DatePicker.RangePicker;

    const ranges = {
      "Hoy": [moment(), moment()],
      "Últimos 7 días": [moment().subtract(7, 'day'), moment()],
      "Últimos 30 días": [moment().subtract(30, 'day'), moment()],
      "Este mes": [moment().startOf('month'), moment().endOf('month')],
      "Último mes": [moment().subtract(1,'months').startOf('month'), moment().subtract(1, 'month').endOf('month')],
    };

    return (
      <Form.Item
        key={`${reset}-${Date.now()}`}
        className="Filter large"
        label={label}
        colon={false}
        name={name}
      >
        <RangePicker
          ranges={ranges}
          onChange={handleChange}
          defaultValue={state.map(value => moment(value))}
          placeholder={[]}
        />
        <Input type="hidden" name={`q[${name}][]`} value={state} />
      </Form.Item>
    );
  }

  let tooltip = label;
  if (hint) {
    tooltip = (
      <>
        <Tooltip
          placement="topLeft"
          title={hint}>
          <InfoCircleOutlined style={{fontSize: 12, marginTop: 4}}/>
        </Tooltip> {label}
      </>
    );
  }

  return (
    <Form.Item
      key={`${reset}-${Date.now()}`}
      className="Filter"
      label={tooltip}
      colon={false}
      name={name}
    >
      {!values ? (
        <Input
          defaultValue={state}
          name={`q[${name}]`}
          placeholder={placeholder}
        />
      ) : (
        <>
          <Select
            defaultValue={state}
            filterOption={handleFilter}
            mode="multiple"
            onChange={handleChange}
            placeholder={placeholder}
          >
            {values.map(item =>
              <Option key={item.code}>{item.name}</Option>
            )}
          </Select>
          <Input type="hidden" name={`q[${name}][]`} value={state} />
        </>
      )}
    </Form.Item>
  );
};

export default Filter;
